import classes from "./SelectAddType.module.scss";
import { useDispatch, useSelector } from "react-redux";
import CardTouch from "../../../../UI/Card/CardTouch/CardTouch";
import pacUsers from "../../../../../assets/images/pacote_usuarios.svg";
import pacLang from "../../../../../assets/images/pacote_idiomas.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const SelectAddType = ({ PlanItems }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const SelectAddUsers = () => {
    navigate('/comprar/turbinar/usuarios',{state:{origin:'internal_flow'}})

    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChooseAdd",
        step: "SelectAddUsers",
      },
    });
  };

  const SelectAddLang = () => {
    navigate('/comprar/turbinar/idiomas',{state:{origin:'internal_flow'}})
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChooseAdd",
        step: "SelectAddLang",
      },
    });
  };

  return (
    <div className={classes.Card}>
      <CardTouch data-testid="boostSubscription_additionalUsers_btn" onClick={SelectAddUsers} classPrimary={classes.CardAddUser}>
        <img className={classes.Image} src={pacUsers} alt="" />
        <div className={classes.Top}>{ t("purchase.add_additional_user")}</div>
      </CardTouch>
      <CardTouch data-testid="boostSubscription_languages_btn" onClick={SelectAddLang} classPrimary={classes.CardAddLang}>
        <img className={classes.Image} src={pacLang} alt="" />
        <div className={classes.Top}>{ t("purchase.games_in_other_languages")}</div>
      </CardTouch>
    </div>
  );
};
export default SelectAddType;
